import { render, staticRenderFns } from "./EmSparePartsInventorySpiList.vue?vue&type=template&id=049b4731&"
import script from "./EmSparePartsInventorySpiList.vue?vue&type=script&lang=js&"
export * from "./EmSparePartsInventorySpiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports